import * as yup from 'yup';
export const couponInitialValue = {
  coupon: ''
};
export const couponSchema = yup.object({
  coupon: yup.string().trim().required()
});